import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 20,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M36.0001 20.3637C36.0001 19.2291 35.8962 18.1382 35.7033 17.0909H20.3267V23.28H29.1133C28.7348 25.28 27.5845 26.9746 25.8554 28.1091V32.1237H31.1319C34.2191 29.3382 36.0001 25.2364 36.0001 20.3637Z",
			fill: "#4285F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20.3266 35.9999C24.7347 35.9999 28.4304 34.5672 31.1317 32.1236L25.8553 28.109C24.3933 29.069 22.5232 29.6363 20.3266 29.6363C16.0742 29.6363 12.475 26.8217 11.1911 23.0399H5.73657V27.1854C8.42303 32.4145 13.9444 35.9999 20.3266 35.9999Z",
			fill: "#34A853"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.1911 23.0399C10.8646 22.0799 10.679 21.0545 10.679 19.9999C10.679 18.9454 10.8646 17.9199 11.1911 16.9599V12.8145H5.73655C4.6308 14.9745 4 17.4181 4 19.9999C4 22.5817 4.6308 25.0254 5.73655 27.1854L11.1911 23.0399Z",
			fill: "#FBBC05"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20.3266 10.3636C22.7236 10.3636 24.8757 11.1709 26.5677 12.7564L31.2505 8.16727C28.423 5.58545 24.7273 4 20.3266 4C13.9444 4 8.42303 7.58545 5.73657 12.8145L11.1911 16.96C12.475 13.1782 16.0742 10.3636 20.3266 10.3636Z",
			fill: "#EA4335"
		})
	]
});
export default SvgGoogleIcon;
